import { singleton } from "./fable_modules/fable-library-js.4.19.0/List.js";
import { parseUrl } from "../Bfs.Web.Portale/MainDispatch.fs.js";
import { value } from "./fable_modules/fable-library-js.4.19.0/Option.js";
import { Msg } from "../Bfs.Web.Portale/Types.fs.js";
import { Encoders } from "../Bfs.Web.Portale/Http.fs.js";
import { addPortalExtra } from "../Bfs.Web.Data.Service.Contracts/KundenportalEncoders.fs.js";
import { extra } from "../Bfs.Web.Data.Service.Contracts/Encoders.fs.js";
import { Registry } from "../Bfs.Web.Portale/WebPart.fs.js";
import { AllParts } from "./WebParts/WebPartRegistry.fs.js";
import { ProgramModule_mkProgram, ProgramModule_withSubscription, ProgramModule_run } from "./fable_modules/Fable.Elmish.4.2.0/program.fs.js";
import { Program_withReactSynchronous } from "./fable_modules/Fable.Elmish.React.4.0.0/react.fs.js";
import { update, init } from "./Kundenportal.MainDispatch.fs.js";
import { view } from "./Kundenportal.View.fs.js";
import "./style.scss";


export function urlSubscription(_arg) {
    return singleton([singleton("url-changed"), (dispatch) => {
        window.addEventListener("hashchange", (arg) => {
            ((_arg_1) => {
                const matchValue = parseUrl(window.location.hash);
                if (matchValue != null) {
                    dispatch(new Msg(2, [value(matchValue)]));
                }
            })(arg);
        });
        return {
            Dispose() {
            },
        };
    }]);
}

Encoders(addPortalExtra(extra));

Registry(AllParts);

ProgramModule_run(Program_withReactSynchronous("elmish-app", ProgramModule_withSubscription(urlSubscription, ProgramModule_mkProgram(init, update, view))));

//# sourceMappingURL=Program.fs.js.map
